module.exports = __webpack_public_path__ + "static/img/9areaB_08.2b97ac7.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/9areaB_08.png
// module id = 1249
// module chunks = 1